/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Neplatné uživatelské jméno nebo heslo.`
};

const da_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ugyldigt brugernavn eller adgangskode.`
};

const de_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ungültige E-Mail oder Passwort.`
};

const en_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Invalid login or password.`
};

const es_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Usuario o contraseña inválidos.`
};

const fr_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Identifiant ou mot de passe invalide.`
};

const hu_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Érvénytelen felhasználónév vagy jelszó.`
};

const it_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Email o password non validi.`
};

const nl_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Ongeldige gebruikersnaam of wachtwoord.`
};

const pl_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Nieprawidłowy e-mail lub hasło.`
};

const pt_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Usuário ou senha inválidos.`
};

const sv_account_login_error = /** @type {(inputs: {}) => string} */ () => {
	return `Fel e-post eller lösenord.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_login_error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_login_error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_login_error", locale)
	if (locale === "cs") return cs_account_login_error(inputs)
	if (locale === "da") return da_account_login_error(inputs)
	if (locale === "de") return de_account_login_error(inputs)
	if (locale === "en") return en_account_login_error(inputs)
	if (locale === "es") return es_account_login_error(inputs)
	if (locale === "fr") return fr_account_login_error(inputs)
	if (locale === "hu") return hu_account_login_error(inputs)
	if (locale === "it") return it_account_login_error(inputs)
	if (locale === "nl") return nl_account_login_error(inputs)
	if (locale === "pl") return pl_account_login_error(inputs)
	if (locale === "pt") return pt_account_login_error(inputs)
	return sv_account_login_error(inputs)
};
export { account_login_error as "account.login_error" }